export default {
  MEMBER: 0,
  INSIDER: 1,
  CORE: 2
}
